import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke322aRequest, Sgke322aResponse, Sgke322aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke322aService {

  /**
   * コンストラクタ
   * @param {Sgke322aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke322aService
   */
  constructor(
    private service: Sgke322aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * SGKE322A_供給停止作業割当検索API呼び出し
   * @param {Sgke322aRequest} request
   * @return {*}  {Observable<Sgke322aResponse>}
   * @memberof UsedSgke322aService
   */
  public doSgke322a(request: Sgke322aRequest): Observable<Sgke322aResponse> {
    return this.service.sgke322aPost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE322A');
          return throwError(err.message);
        })
      );
  }
}
